import { useCookie } from '@zapier/cookies';

export function useIsClaudeMCPReferrer(): boolean {
  const [zapierMcpReferrer] = useCookie('zapier_mcp_referrer');
  return zapierMcpReferrer === 'claude';
}
